<script setup>
  import LayoutFooter from '@/components/layout/layoutFooter.vue';
  import layoutShell from '@/components/layout/layoutShell.vue';
    import compExtensionTable from '@/components/hackwatch/compExtensionTable.vue';
</script>
<template>
    <!-- Sidebar -->
    <layoutShell>
  <div class="layout-content-wrapper">
    <main class="content">
        <compExtensionTable />
    </main>
  </div>
  <div class="layout-footer">
    <LayoutFooter />
  </div>
</layoutShell>
</template>



